import { Helmet } from "react-helmet";

interface SEOHeadProps {
  title: string;
  description: string;
  path: string;
  noindex?: boolean;
  canonical?: string;
  /** Absolute or root-relative path to OG image */
  ogImage?: string;
  /** Optional JSON-LD object(s) rendered as application/ld+json */
  jsonLd?: object | object[];
}

const SITE = "https://www.johnsellsnj.realestate";
// Site-wide share image (the same preview image index.html uses).
const DEFAULT_OG =
  "https://pub-bb2e103a32db4e198524a2e9ed8f35b4.r2.dev/f3069ae2-9b2b-44bf-affc-c8b123103f2f/id-preview-4d0a9a3d--434715b4-542d-48b6-b326-0b986d8a1396.lovable.app-1779214577720.png";

export const SITE_URL = SITE;

const SEOHead = ({ title, description, path, noindex, ogImage, canonical, jsonLd }: SEOHeadProps) => {
  const url = canonical || `${SITE}${path}`;
  const image = ogImage
    ? ogImage.startsWith("http")
      ? ogImage
      : `${SITE}${ogImage}`
    : DEFAULT_OG;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="John Mastroianni | Align Right Realty - Homekey" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {(Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : []).map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
};

export default SEOHead;
